import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { IChatBotV2SesionData } from '../../../models/chat-bot-v2.model';
import { LoadingService } from '../../../services';
import { AlertService } from '../../../services/alert/alert.service';
import { ChatBotV2DataService } from '../../../services/chat-bot-v2/chat-bot-v2.data.service';
import { ChatBotV2Service } from '../../../services/chat-bot-v2/chat-bot-v2.service';

@Component({
  selector: 'app-chat-bot-asesor-v2-dashboard',
  templateUrl: './chat-bot-asesor-v2-dashboard.component.html',
  styles: [
    ':host::ng-deep .mat-column-ultimoMensaje * { color: #5A646E; font-size: 14px; }',
  ],
  host: {
    class: 'block rounded-[10px] shadow'
  }
})
export class ChatBotAsesorV2DashboardComponent implements OnInit {

  _data: IChatBotV2SesionData[] = [];
  columnas: string[] = ['fechaCreacion', 'titulo', 'ultimoMensaje', 'ultimaModificacion', 'irChat' ];
  dataSource = new MatTableDataSource<IChatBotV2SesionData>([]);
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(
    public loaderService: LoadingService,
    public chatBotV2DS: ChatBotV2DataService,
    public chatBotV2S: ChatBotV2Service,
    private alertS: AlertService
  ) {
    this.chatBotV2DS.recargarDashboard.subscribe(() => this.obtenerHistorial());
  }

  ngOnInit(): void {
    setTimeout(() => this.obtenerHistorial());
  }

  async obtenerHistorial() {
    try {
      this.loaderService.showLoading();
      const resp = await this.chatBotV2S.obtenerSesiones();
      this.dataSource.data = resp.data;
      this._data = resp.data;
      this.dataSource.sort = this.sort;
    } catch (error) {
      this.alertS.showSnackBarTopRight({
        titulo: 'Error',
        mensaje: 'El servicio ha fallado, inténtalo de nuevo más tarde.',
        severity: 'error',
        enFila: true
      });
    } finally {
      this.loaderService.hideLoading();
    }
  }

  irChat(selectRow: IChatBotV2SesionData) {
    this.chatBotV2DS.sidenav = true;
    this.chatBotV2DS.selectRow = selectRow;
  }

}
